import { UserService } from '@/app/plateformebeneficiaire/core';
import { CommonModule } from '@angular/common';
import { Component, inject, computed, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { Message } from 'primeng/message';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-myprofile-sidebar',
  imports: [
    CommonModule,
    FormsModule,
    ProgressSpinnerModule,
    TooltipModule,
    ToastModule,
    InputTextModule,
    ButtonModule,
    Message,
    DialogModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './myprofile-sidebar.component.html',
  styleUrl: './myprofile-sidebar.component.scss',
  standalone: true
})
export class MyProfileSidebarComponent {
  #userService = inject(UserService);
  #confirmationService = inject(ConfirmationService);
  #messageService = inject(MessageService);
  #userInfoQuery = this.#userService.getUserInfos();
  userInfo = computed(() => this.#userInfoQuery.data());

  nomPrenom = computed(() => {
    const info = this.userInfo();
    return info ? `${info.prenom} ${info.nom}` : '';
  });
  entreprise = computed(() => this.userInfo()?.entrepriseNom ?? '');
  email = computed(() => this.userInfo()?.email ?? '');
  telephone = computed(() => this.userInfo()?.phoneNumber ?? '');

  isEditingEmail = signal(false);
  isEditingTelephone = signal(false);

  errorEmail: string = '';

  tempEmail = signal('');
  tempTelephone = signal('');

  displayConfirmUpdateEmailModal: boolean = false;

  askUpdateEmail() {
    this.displayConfirmUpdateEmailModal = true;
  }

  startEditEmail() {
    this.tempEmail.set(this.email());
    this.isEditingEmail.set(true);
  }

  startEditTelephone() {
    this.tempTelephone.set(this.telephone());
    this.isEditingTelephone.set(true);
  }

  saveEmail() {
    this.#userService.updateUserInfos.mutate({
      email: this.tempEmail(),
      phoneNumber: this.userInfo()?.phoneNumber ?? ''
    }, {
      onSuccess: () => {
        this.#userService.logout();
      },
      onError: (e: any) => {
        this.errorEmail = e.error;
        this.displayConfirmUpdateEmailModal = false;
      }
    });
  }

  saveTelephone() {
    this.#userService.updateUserInfos.mutate({
      email: this.userInfo()?.email ?? '',
      phoneNumber: this.tempTelephone()
    }, {
      onSuccess: () => {
        this.isEditingTelephone.set(false);
      }
    });
  }

  cancelEditEmail() {
    this.isEditingEmail.set(false);
    this.displayConfirmUpdateEmailModal = false;
    this.#userService.refetchUser();
  }

  // Annuler l'édition du téléphone
  cancelEditTelephone() {
    this.isEditingTelephone.set(false);
    this.#userService.refetchUser();
    // this.tempTelephone.set(this.telephone());
  }

  deleteAccount() {
    this.#confirmationService.confirm({
      message: 'Etes-vous sur de vouloir supprimer votre accès bénéficiaire ? Cette action est irréversible.',
      header: 'Suppression du compte',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui, supprimer mon compte',
      rejectLabel: 'Annuler',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
      accept: () => {
        this.#userService.deleteAccount.mutate(undefined, {
          onSuccess: () => {
            this.#messageService.add({
              severity: 'warn',
              summary: 'Compte supprime',
              detail: 'Votre compte à été supprimé. Vous allez être deconnecté.'
            });
            setTimeout(() => this.#userService.logout(), 2000);
          },
          onError: () => {
            this.#messageService.add({
              severity: 'error',
              summary: 'Erreur',
              detail: 'La suppression du compte a echoue.'
            });
          }
        });
      }
    });
  }
}